import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';


@Component({
    selector: 'pulse-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseContentComponent implements OnDestroy {
    // @HostBinding('@routerTransitionUp') routeAnimationUp = false;
    // @HostBinding('@routerTransitionDown') routeAnimationDown = false;
    // @HostBinding('@routerTransitionRight') routeAnimationRight = false;
    // @HostBinding('@routerTransitionLeft') routeAnimationLeft = false;
    // @HostBinding('@routerTransitionFade') routeAnimationFade = false;

    constructor() {

    }

    ngOnDestroy() {
        // this.onConfigChanged.unsubscribe();
    }
}
